import { Component, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../models/user.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeSalaryComponent } from './change-salary/change-salary.component';
import { GetClotheComponent } from '../view-user-profile/get-clothe/get-clothe.component';
import { BiometricsComponent } from './biometrics/biometrics.component';
import { AdminService } from '../../../services/admin.service';
import { GroupResponse, UserInfoBody } from '../../../services/admin.service.types';
import { ChangeExperienceComponent } from './change-experience/change-experience.component';
import { ReportDatepickerComponent } from '../../../modals/report-datepicker.component';
import { ReportType } from '../../../models/report-type.model';
import { AppConstants } from './app.constants';
import { UserProfile, ClothesInfo, UserWrapper, GroupWithPosition } from './view-user-profile.types';

@Component({
  selector: 'app-view-user-profile',
  templateUrl: './view-user-profile.component.html',
  styleUrls: ['./view-user-profile.component.css']
})
export class ViewUserProfileComponent implements OnInit {

  public isLoaded = false;
  public user: UserProfile;
  public notFound = false;
  public request = false;
  public isAdmin = false;
  public isHead = false;
  public isUser = false;
  public userActive: User;
  public userId: string;
  public wrapperUser: UserWrapper;
  public errorMessage = false;
  public visible = false;
  public infoClothes: ClothesInfo;
  public isCheckTimetablePF: boolean;
  public isCheckTimetable: boolean;
  public ountRecyclingB: boolean;
  public checkId = true;

  private selectMainGroupId: string;
  private currentUserMainGroupId: string;
  private groupList: GroupWithPosition[];
  private groupForUser: GroupResponse[];

  constructor(public userService: UserService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private adminService: AdminService,
    private timeFormatter: TimeFormatterService) {
  }

  ngOnInit(): void {
    this.initializeUserRoles();
    this.getUserInfo();
    
    if (this.isHead || this.isAdmin) {
      this.checkClothes();
    }
    this.loadUserData();
  }

  private initializeUserRoles(): void {
    this.userActive = this.userService.getLocal();
    this.isAdmin = this.userActive.roles.includes(AppConstants.ROLES.ADMIN);
    this.isHead = this.userActive.roles.includes(AppConstants.ROLES.HEAD);
    this.isUser = this.userActive.roles.includes(AppConstants.ROLES.USER);
  }

  open(): void {
    const modalRef = this.modalService.open(ReportDatepickerComponent);
    modalRef.componentInstance.reportType = ReportType.BY_PROFILE;
    modalRef.componentInstance.userId = this.route.snapshot.params['id'];
    modalRef.result.then((result) => {
      if (result) {
        this.user.dateOfEmployment = result;
      }
    });
  }

  private getList(response: HttpResponse<UserProfile>, user: UserProfile): void {
    const currentUserId = this.userService.getLocal().id;
    this.adminService.getMyGroups(currentUserId).subscribe(
      (res: HttpResponse<GroupResponse[]>) => {
        this.groupForUser = res.body;
        this.checkVisible(response, user, this.groupForUser);
      }
    );
  }

  postiruem(tumbler: boolean): void {
    this.adminService.postiruem(this.user.id, tumbler).subscribe(
      () => this.loadUserData()
    );
  }

  postiruemOvertime(tumbler: boolean): void {
    this.adminService.postiruemOver(this.user.id, tumbler).subscribe(
      () => this.loadUserData()
    );
  }

  private loadUserData(): void {
    const userId = this.getUserId();
    const apiCall = this.getUserApiCall(userId);
    
    apiCall.subscribe(
      (response: HttpResponse<UserProfile>) => {
        if (response.status === AppConstants.HTTP_STATUS.OK) {
          this.updateUserSettings(response.body);
          this.loadGroupList();
        }
      }
    );
  }

  private updateUserSettings(userData: UserProfile): void {
    this.user = userData;
    this.isCheckTimetablePF = userData.payrollMethod;
    this.isCheckTimetable = userData.checkTimetable;
    this.ountRecyclingB = userData.acceptOvertime;
  }

  changeTime(status: string): void {
    const isOn = status === 'ON';
    this.isCheckTimetable = isOn;
    this.submit(isOn);
  }

  private loadGroupList(): void {
    this.adminService.getUserInfo(this.user.id).subscribe(
      (response: HttpResponse<UserInfoBody>) => {
        this.groupList = response.body.groupsWithPositions;
      }
    );
  }

  private submit(checkTimetable: boolean): void {
    this.user.checkTimetable = checkTimetable;
    this.wrapperUser = {
      user: this.user,
      groupsWithPositions: this.groupList
    };
    this.adminService.updateUser(this.wrapperUser).subscribe();
  }

  private getUserInfo(): void {
    const userId = this.getUserId();
    const apiCall = this.getUserApiCall(userId);
    
    apiCall.subscribe(
      (response: HttpResponse<UserProfile>) => this.handleUserInfoResponse(response),
      () => this.errorMessage = true
    );
  }

  private getUserId(): string {
    return this.route.snapshot.params['id'];
  }

  private getUserApiCall(userId: string) {
    return this.userService.getUserFromAPI(userId);
  }

  private handleUserInfoResponse(response: HttpResponse<UserProfile>): void {
    this.errorMessage = false;
    this.userId = this.getUserId();
    this.user = response.body;
    this.isLoaded = true;

    switch (response.status) {
      case AppConstants.HTTP_STATUS.OK:
        this.handleSuccessResponse(response);
        break;
      case AppConstants.HTTP_STATUS.NO_CONTENT:
        this.setUserState(true, false);
        break;
      case AppConstants.HTTP_STATUS.PRECONDITION_FAILED:
        this.setUserState(false, true);
        break;
    }
  }

  private handleSuccessResponse(response: HttpResponse<UserProfile>): void {
    this.getList(response, this.user);
    this.checkId = this.userId === this.userActive.id ? this.isAdmin : true;
    this.setUserState(false, false);
  }

  private checkClothes(): void {
    this.userService.getClothes(this.route.snapshot.params['id']).subscribe(
      (response: HttpResponse<ClothesInfo>) => {
        this.infoClothes = response.body;
        const status = this.infoClothes.clothesStatus;
        if (AppConstants.CLOTHES_STATUS[status]) {
          this.infoClothes.clothesStatus = AppConstants.CLOTHES_STATUS[status];
        }
      },
      () => {
        this.infoClothes = null;
      }
    );
  }

  biometrics(): void {
    this.openModal(BiometricsComponent, (modal) => {
      if (this.user.parametersUser) {
        modal.componentInstance.setValue(this.user.parametersUser);
      }
    }, () => this.getUserInfo());
  }

  openEditPos(): void {
    this.openModal(ChangeSalaryComponent, (modal) => {
      modal.componentInstance.setValue(this.user.salary);
    }, () => this.getUserInfo());
  }

  openClothes(): void {
    this.openModal(GetClotheComponent, null, () => this.checkClothes());
  }

  private openModal(component: any, configure?: (modal: any) => void, onSuccess?: () => void): void {
    const modalRef = this.modalService.open(component);
    modalRef.componentInstance.setId(this.user.id);
    
    if (configure) {
      configure(modalRef);
    }

    modalRef.result.then((result) => {
      if (result === AppConstants.MODAL_RESULT.OK && onSuccess) {
        onSuccess();
      }
    });
  }

  private checkVisible(response: HttpResponse<UserProfile>, user: UserProfile, groups: GroupResponse[]): void {
    this.selectMainGroupId = response.body.mainGroup;
    const currentUserId = this.userService.getLocal().id;
    const currentUserMainGroup = this.userService.getLocal().mainGroup;
    
    let matchingGroupId: string;
    groups.forEach(element => {
      if (element && element.head && element.head.id === currentUserId && element.id === this.selectMainGroupId) {
        matchingGroupId = element.id;
      }
    });
    
    this.currentUserMainGroupId = currentUserMainGroup;
    const isMainGroupMatch = this.selectMainGroupId === user.mainGroup;
    const isHeadOrSelf = matchingGroupId === this.selectMainGroupId || this.route.snapshot.params['id'] === currentUserId;
    this.visible = isMainGroupMatch && isHeadOrSelf;
  }

  private setUserState(notFound: boolean, request: boolean): void {
  this.notFound = notFound;
  this.request = request;
}
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile.component.ts